import React from "react";

import Typography from "@material-ui/core/Typography";

interface Props {
  nodes?: any[];
  panelCollectionName: string;
  // panelId?: string;
  // panelName: String;
  panelDefinition: any;
  title: string;
  externalUrl: string;
}

function ExternalUrlPanel(props: Props) {
  const {
    // nodes,
    // panelCollectionName,
    // // panelId,
    // // panelName,
    // panelDefinition,
    title,
    externalUrl,
  } = props;

  return (
    <>
      <Typography variant="subtitle2">{title}</Typography>
      <iframe
        src={externalUrl}
        title={title}
        id="myIframe"
        // width="990"
        width="100%"
        seamless
        style={{
          overflow: "hidden",
          border: "none",
          paddingLeft: "10px",
          height: "100vh", // TODO set to 100%
        }}
      ></iframe>
    </>
  );
}

export default ExternalUrlPanel;
